import React from 'react';
import { Typography, Box } from '@mui/material';
import SideMenu from '../components/SideMenu'; // Caminho correto para o SideMenu

const Settings = () => {
  return (
    <Box sx={{ display: 'flex' }}>
      {/* SideMenu */}
      <Box sx={{ width: '250px' }}>
        <SideMenu />
      </Box>

      {/* Conteúdo principal */}
      <Box sx={{ flexGrow: 1, padding: '20px' }}>
        <Typography variant="h4" gutterBottom>
          Configuração
        </Typography>
        <Typography variant="body1">
     
        </Typography>
      </Box>
    </Box>
  );
};

export default Settings;
